import React, { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../../assets/images/logo-light.webp";
import Dropdown from "react-bootstrap/Dropdown";
import {
  getModuleAccess,
  getUserName,
  getValueByKey,
  removeLoggedInUserDetails,
} from "../../../utils/authUtils";
import {
  ApiResponseMessage,
  SignOutTostrMessage,
} from "../../../helper/tosterHelper";
import NotificationBell from "../NotificationBell";
import {
  AchSvg,
  ActivityLogSvg,
  GuideInteractiveSvg,
  LinkSvg,
  LogoutSvg,
  MemberUserGuideSvg,
  SettingSvg,
  SupportSvg,
  SyncSvg,
  UserGuideSvg,
  VendorSvg,
} from "../../CommonSvg";
import {
  RoleWiseModule,
  getInitials,
} from "../../../utils/generalUtils";
import { getLoginClear } from "../../../redux/admin/auth/login/action";
import { AdminAccess, MarketingAccess, SUCCESS, StaffAccess, SuperAdminAccess, } from "../../../constant/commonConstants";
import { useEffect } from "react";
import { zohoStoreListRequest } from "../../../redux/admin/members/action";
import { commonConfirmBox } from "../../../helper/messagehelpers";
import { connect } from "react-redux";
import CustomisedModal from "../../Modal/CustomisedModal";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { getDefaultPathRequest } from "../../../redux/admin/role/action";
import { getAmericaNewYorkTimeZoneDate } from "../../../helper/DataTimeHelpers";
import { invokeApi } from "../../../helper/axiosHelper";

const Header = ({ zohoStoreListRequest, setDefaultPathRequest }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const agreements = JSON.parse(getValueByKey("agreements"))
  console.log(agreements, "agreementsagreements")
  const logout = async () => {
    /* close the activity trail before the token is removed - after that there
       is nothing left to authenticate the call with */
    await invokeApi("post", "/logout", {}, {});
    navigate("/admin/login");
    getLoginClear();
    SignOutTostrMessage();
    removeLoggedInUserDetails();
  };
  const authName = getUserName();
  useEffect(() => {
    if (location.pathname != "/admin/promotion") {
      localStorage.removeItem("activeTab");
    }
  }, [location.pathname]);
  const [isModal, setIsModal] = useState(false);
  const [defaultPath, setDefaultPath] = useState({
    favouriteMenu: "/admin/home",
  });
  const heandalSetting = () => {
    setIsModal(!isModal);
  };
  const adminLinks = [
    RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess, MarketingAccess) && {
      label: "Dashboard",
      to: "/admin/home",
    },
    RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess, MarketingAccess) && {
      label: "Promotions",
      to: "/admin/promotion",
    },
    RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess) && {
      label: "Members",
      to: "/admin/members",
    },
    RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess) && {
      label: "Inquiry",
      to: "/admin/inquiry",
    },
    RoleWiseModule(AdminAccess, SuperAdminAccess) && {
      label: "ACH Management",
      to: "/admin/ach",
    },
    RoleWiseModule(AdminAccess, SuperAdminAccess) && {
      label: "User Management",
      to: "/admin/user",
    },
  ].filter((link) => link);

  const vendorLinks = [
    {
      label: "Vendor Program",
      to: "/admin/vendor",
    },
    {
      label: "Vendor List",
      to: "/admin/vendor-list",
    },
    {
      label: "Document Management",
      to: "/admin/document-management",
    },
    // {
    //   label: "Vendor Log",
    //   to: "/admin/vendor-log",
    // },
  ];

  const isVendorLinkActive = (to) =>
    location.pathname === to || location.pathname.startsWith(`${to}/`);

  useEffect(() => {
    if (getValueByKey("favouriteMenu")) {
      setDefaultPath({ favouriteMenu: getValueByKey("favouriteMenu") });
    }
  }, [getValueByKey("favouriteMenu")]);
  const lastSync = getValueByKey("lastSync");
  const moduleAccess = getModuleAccess();
  return (
    <>
      <Navbar className={location.pathname === "/" ? "dashboard-page" : ""}>
        <Container>
          <Navbar.Brand>
            <Link to="/admin/home">
              <img alt="Logo" className="logo_main" src={Logo} />
            </Link>
          </Navbar.Brand>

          <Nav className="">
            {RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess, MarketingAccess) && (
              <Nav.Link as={NavLink} to="/admin/home">
                Dashboard
              </Nav.Link>
            )}
            {RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess, MarketingAccess) && (
              <Nav.Link as={NavLink} to="/admin/promotion">
                Promotions
              </Nav.Link>
            )}
            {RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess) && (
              <Nav.Link as={NavLink} to="/admin/members">
                Members
              </Nav.Link>
            )}
            {/* {RoleWiseModule(AdminAccess, StaffAccess) && (
              <Nav.Link as={NavLink} to="/admin/inquiry">
                Inquiry
              </Nav.Link>
            )} */}
            <Dropdown
              className={`vendor_dropdown ${
                vendorLinks.some((link) => isVendorLinkActive(link.to))
                  ? "active"
                  : ""
              }`}
            >
              <Dropdown.Toggle as={Nav.Link} id="vendor-dropdown">
                Vendor Management
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {vendorLinks.map((link) => (
                  <Dropdown.Item
                    key={link.to}
                    className={isVendorLinkActive(link.to) ? "active" : ""}
                    onClick={() => navigate(link.to)}
                  >
                    {/* <VendorSvg /> */}
                    {link.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {/* <Nav.Link as={NavLink} to="/admin/vendor-contact">
              Vendor Contacts
            </Nav.Link> */}
            {(RoleWiseModule(SuperAdminAccess) || moduleAccess?.achManagement) && (
              <Nav.Link as={NavLink} to="/admin/ach">
                ACH Management
              </Nav.Link>
            )}
            {RoleWiseModule(AdminAccess, SuperAdminAccess, StaffAccess) && (
              <Nav.Link as={NavLink} to="/admin/rebate">
                Rebates
              </Nav.Link>
            )}
            {RoleWiseModule(
              AdminAccess,
              StaffAccess, SuperAdminAccess,
              MarketingAccess
            ) && (
                <Nav.Link as={NavLink} to="/admin/support">
                  Support Request
                </Nav.Link>
              )}

            {RoleWiseModule(AdminAccess, SuperAdminAccess,
              StaffAccess,
              MarketingAccess) && (
                <Nav.Link as={NavLink} to="/admin/newsletter">
                  Newsletter
                  {/* & Vendor program */}
                </Nav.Link>
              )}

            {RoleWiseModule(AdminAccess, SuperAdminAccess) && (
              <Nav.Link as={NavLink} to="/admin/user">
                User Management
              </Nav.Link>
            )}
            <div className="right_header">
              {/* left of the account menu, the way the vendor portal has it */}
              <NotificationBell />

              <Dropdown className="profile_btn">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="position-relative"
                >
                  <div className="profile_name">
                    <h5>{authName}</h5>
                    <div>
                      <p>
                        {RoleWiseModule(AdminAccess) && "Admin"}
                        {RoleWiseModule(StaffAccess) && "Staff"}
                        {RoleWiseModule(MarketingAccess) && "Marketing"}
                        {RoleWiseModule(SuperAdminAccess) && "Super Admin"}
                      </p>
                    </div>
                  </div>
                  <span className="user-profile">{getInitials(authName)}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={heandalSetting}>
                    <SettingSvg />
                    Setting
                  </Dropdown.Item>
                  {RoleWiseModule(AdminAccess, SuperAdminAccess) && (
                    // <Nav.Link as={NavLink} to="/admin/support-details">

                    // </Nav.Link>
                    <Dropdown.Item className={location.pathname === "/admin/link-management" ? "active" : ""} onClick={() => navigate("/admin/link-management")}>
                      <LinkSvg />
                      Link Management
                    </Dropdown.Item>
                  )}

                  {RoleWiseModule(AdminAccess, SuperAdminAccess) && (
                    // <Nav.Link as={NavLink} to="/admin/support-details">

                    // </Nav.Link>
                    <Dropdown.Item className={location.pathname === "/admin/support-details" ? "active" : ""} onClick={() => navigate("/admin/support-details")}>
                      <SupportSvg />
                      Support Details
                    </Dropdown.Item>
                  )}
                  {RoleWiseModule(AdminAccess, SuperAdminAccess) && (
                    <Dropdown.Item
                      // disabled={isZohoSyncEnabled}
                      onClick={async () => {
                        const response = await commonConfirmBox(
                          "Are you sure you want to start Zoho sync?"
                        );
                        if (response) {
                          zohoStoreListRequest();
                          ApiResponseMessage(
                            "Zoho Sync started successfully",
                            SUCCESS
                          );
                        }
                      }}
                    >
                      <SyncSvg />
                      <span>
                        <span>Sync Zoho </span>
                        {lastSync && (
                          <small className="text-muted mt-1 sync-data">
                            <span>
                              {/* <Date_Svg /> */}
                              {getAmericaNewYorkTimeZoneDate(lastSync)}
                            </span>
                          </small>
                        )}
                      </span>
                    </Dropdown.Item>
                  )}
                  {RoleWiseModule(AdminAccess, SuperAdminAccess) && (
                    <Dropdown.Item
                      className={
                        location.pathname === "/admin/user-logs" ? "active" : ""
                      }
                      onClick={() => navigate("/admin/user-logs")}
                    >
                      <ActivityLogSvg />
                      User Logs
                    </Dropdown.Item>
                  )}
                  {agreements.map((data) => {
                    return (
                      <Dropdown.Item
                        key={data.id} // it's good practice to add a key
                        onClick={() => {
                          if (data.openNewTab) {
                            window.open(data.url, "_blank");
                          } else {
                            window.location.href = data.url;
                          }
                        }}
                      >
                        <UserGuideSvg />
                        <span>{data.title}</span>
                      </Dropdown.Item>
                    );
                  })}

                  {/* <Dropdown.Item
                      onClick={() =>
                        window.open(
                          "https://hragroup330-my.sharepoint.com/personal/it_hraga_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fit%5Fhraga%5Fcom%2FDocuments%2FTRAINING%20MATERIAL%2FMember%20Portal%20Application%2FMember%20Application%20Admin%5Fside%20User%20Guide%2Epdf&parent=%2Fpersonal%2Fit%5Fhraga%5Fcom%2FDocuments%2FTRAINING%20MATERIAL%2FMember%20Portal%20Application&ga=1"
                        )
                      }
                    >
                      <UserGuideSvg />
                      <span>Admin Portal User Guide</span>
                    </Dropdown.Item> */}
                  {/* <Dropdown.Item
                    onClick={() =>
                      window.open(
                        "https://hragroup330-my.sharepoint.com/personal/it_hraga_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fit%5Fhraga%5Fcom%2FDocuments%2FTRAINING%20MATERIAL%2FMember%20Portal%20Application%2FMember%20Application%20Member%20User%20Guide%2Epdf&parent=%2Fpersonal%2Fit%5Fhraga%5Fcom%2FDocuments%2FTRAINING%20MATERIAL%2FMember%20Portal%20Application&ga=1"
                      )
                    }
                  >
                    <MemberUserGuideSvg />
                    <span>Member's User Guide</span>
                  </Dropdown.Item> */}
                  <Dropdown.Item onClick={logout}>
                    <LogoutSvg />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Nav>
        </Container>
      </Navbar>

      <CustomisedModal
        modalView={isModal}
        customClass={"category-modal"}
        modalName={"Setting"}
        onModalDismiss={heandalSetting}
      >
        <FormGroup>
          <Input
            id="path"
            name="select"
            type="select"
            className="form-select"
            onChange={(e) => {
              setDefaultPath({ favouriteMenu: e.target.value });
            }}
            value={defaultPath.favouriteMenu}
          >
            {adminLinks.map(
              (link, index) =>
                link && (
                  <option key={index} value={link.to}>
                    {link.label}
                  </option>
                )
            )}
          </Input>
          <Label className="form-label" htmlFor="year">
            Set Your Default Page
          </Label>
        </FormGroup>
        <div className="text-center">
          <Button
            color="primary"
            onClick={() => {
              setDefaultPathRequest(defaultPath);
              heandalSetting();
            }}
          >
            Submit
          </Button>
        </div>
      </CustomisedModal>
    </>
  );
};

const mapStateToProps = ({ profileData }) => {
  let StoreDetail = null;
  return {
    StoreDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zohoStoreListRequest: () => dispatch(zohoStoreListRequest()),
    setDefaultPathRequest: (data) => dispatch(getDefaultPathRequest(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
